import { Component, OnInit, OnDestroy, OnChanges, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DadosContratosModel } from './../model/dados-contrato.model';
import { BehaviorSubject, Subscription } from 'rxjs';
import Utils from '../utils/utils';


@Component({
  selector: 'app-contrato-amplo',
  templateUrl: './contrato-amplo.component.html',
  styleUrls: ['./contrato-amplo.component.css']
})
export class ContratoAmploComponent implements OnInit {

  // @Input() nomeperfil: string; // decorate the property with @Input()
  @Input() titulo: string;
  @Input() infoContratos: DadosContratosModel;

  public inscricaoFormatada: string;
  perfilAmplo: boolean = false;
  perfilRestrito: boolean = false;


  ngOnInit() {
    if (this.infoContratos.tipoContrato === "RESTRITO") {
      this.perfilRestrito = true;
    }else{
      this.perfilAmplo = true;
    }
    
    this.formatarInscricao();
  }

  public formatarInscricao() {

    const tipoInsc = this.infoContratos.tipoInscricao;
    this.inscricaoFormatada = Utils.formatarInscricao(this.infoContratos.inscricao, tipoInsc);
    switch (tipoInsc) {
      case '1':
        this.inscricaoFormatada = Utils.mascararCNPJ(this.inscricaoFormatada);
        break;
      case '3':
        this.inscricaoFormatada = Utils.mascararCPF(this.inscricaoFormatada);
        break;
      case '2':
        this.inscricaoFormatada = Utils.mascararCEI(this.inscricaoFormatada);
        break;
    }
  }
}
